import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const SeverityIcon = (props: SvgProps) => <Svg
  width='16'
  height='16'
  viewBox='0 0 16 16'
  fill='none'
  {...props}
>
  <Path
    d='M8.00001 14C5.40001 14 3.33334 12.6667 3.33334 9.33333C3.33334 6 6.66668 6 6.66668 2C8.66668 3.33333 9.58001 4.73333 10 7.33333C10.6777 6.85569 11.1531 6.14262 11.3333 5.33333C12 6 12.6667 8 12.6667 9.33333C12.6667 11.4267 11.8133 14 8.00001 14Z'
    stroke={props.color ?? '#0058AD'}
    strokeWidth='1.5'
    strokeLinecap='round'
    strokeLinejoin='round' />
</Svg>;

export default SeverityIcon;
